import { useEffect, isValidElement } from "react";
import { useSelector } from "react-redux";
import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import { getFlightDetailsFetchStatus } from "../../../store/flightDetails/selectors.js";
import useFlightDetailsInfoController from "../../../components/elements/FlightDetailsInner/components/FlightDetailsInfo/useFlightDetailsInfo.controller.js";
export const flights_funnel_new_fd_page_desktop = createTrackingUtils({
    name: "flights_funnel_new_fd_page_desktop",
    defaultStage: 1,
    stages: {
        main: 1,
        direct: 2,
        meta: 3,
        oneWay: 4,
        roundTrip: 5,
        noLayover: 6,
        someLayover: 7,
        flexibilityProtection: 8,
        farerules: 9
    },
    goals: {
        expandDirect: 1,
        expandNonDirect: 2,
        flexibilityProtectionClick: 3,
        expandFD: 4,
        clickLink: 5
    }
});
function isLayover(flight) {
    return flight?.segments?.some((segment) => segment.legs.length > 1) ?? false;
}
export function FlightsFunnelNewFdPageDesktopTracker({ flight }) {
    const exp = flights_funnel_new_fd_page_desktop;
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    const { isDesktop, isDirect, isMeta, isRountrip, isOneWay } = useProfiler();
    const { itemsMap } = useFlightDetailsInfoController({ flight, fetchStatus });
    useEffect(() => {
        if (!isDesktop())
            return;
        if (!isLayover(flight))
            exp.stages.noLayover();
        if (isLayover(flight))
            exp.stages.someLayover();
        if ((itemsMap?.extraProductsInfo?.content !== undefined &&
            isValidElement(itemsMap.extraProductsInfo.content) &&
            !itemsMap.extraProductsInfo.hasGeniusFlexTicketOnly) ||
            isValidElement(itemsMap?.extraProductsInfo2?.content)) {
            exp.stages.flexibilityProtection();
        }
        if (isValidElement(itemsMap?.fareRulesInfoWithPartials?.content) ||
            isValidElement(itemsMap?.fareRulesStatusInfo?.content)) {
            exp.stages.farerules();
        }
    }, [exp, flight, itemsMap, isDesktop]);
    useEffect(() => {
        if (!isDesktop())
            return;
        exp.stages.main();
        if (isDirect())
            exp.stages.direct();
        if (isMeta())
            exp.stages.meta();
        if (isRountrip())
            exp.stages.roundTrip();
        if (isOneWay())
            exp.stages.oneWay();
    }, [exp, isDesktop, isDirect, isMeta, isRountrip, isOneWay]);
    return null;
}
